// Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved.

import I18nProtolabs, {
    languageCode as defaultLanguageCode,
} from 'i18n-protolabs';

// eslint-disable-next-line new-cap
const i18n = I18nProtolabs.VueI18n({allowComposition: true}, false);

export async function loadDefaultLanguageAsync(
    languageOverride: string | null
) {
    const desiredLanguage = languageOverride
        ? languageOverride
        : defaultLanguageCode;
    await i18n.loadLanguageAsync(desiredLanguage);
}

export default i18n;
